// removed by extract-text-webpack-plugin
module.exports = {"buttonRow":"direction-button-row-module__buttonRow___1TzmS","marginForIframe":"direction-button-row-module__marginForIframe___1lSQS","buttonWrapper":"direction-button-row-module__buttonWrapper___8qKC9","buttonContent":"direction-button-row-module__buttonContent___3MMjf","buttonTitle":"direction-button-row-module__buttonTitle___19tYU","centered":"direction-button-row-module__centered___35CrU","tooltipPointer":"direction-button-row-module__tooltipPointer___gUtYb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/direction-button-row/direction-button-row.module.scss
// module id = 153
// module chunks = 0